module.exports = __webpack_public_path__ + "img/logo.2eaadde0.png";